import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { getAccessSettings, removeNonNumeric } from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";

export default function Triggers() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showUserList, setShowUserList] = useState(false);

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);
  const [JLRRecipientsList, setJLRRecipientsList] = useState<any>([]);
  const [ImporterRecipientsList, setImporterRecipientsList] = useState<any>([]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
  }, []);

  useEffect(() => {
    if (filterData.ProgramID > 0) {
      IBBProgramGetScorecardListForScorecard();
    }
  }, [filterData.ProgramID, filterData.QuarterID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            if (
              result[0].length > 0 &&
              globalState.AppAccessLevelData.DID > 0
            ) {
              let IBBScorecardID = result[0][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramUpdateProgramScorecardStatusAndHandleActions(
    Status: number,
    SubStatus: number,
    Type: number,
    ActionType: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.type = Type;
    object.status = Status;
    object.substatus = SubStatus;
    object.actiontype = ActionType;
    if (SubStatus != undefined && SubStatus > 0) {
      setShowAnimation(true);
      axiosAuth
        .post(
          AppContext.AppBaseURL +
            "api/IBBProgram/IBBProgramUpdateProgramScorecardStatusAndHandleActions",
          object
        )
        .then((response) => {
          setShowAnimation(false);
          if (response.data.Status === 1) {
            let result = response.data.Data;
            setShowPopup(true);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else AppContext.ShowNotification("error", "Please select stage.");
  }

  function GetUserListApplicationAccessSettingsForAccessObject(
    AccessType: number,
    ObjectID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.accesstype = AccessType;
    object.objectid = ObjectID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/GetUserListApplicationAccessSettingsForAccessObject",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setJLRRecipientsList(result[0]);
            setImporterRecipientsList(result[1]);
          }
          setShowUserList(true);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.isConfirm === true) {
      if (obj.ID == 1) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(2, 2, 1, 1);
      }
      if (obj.ID == 2) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(3, 1, 2, 2);
      }
      if (obj.ID == 3) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(3, 5, 3, 3);
      }
      if (obj.ID == 4) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(3, 6, 4, 4);
      }
      if (obj.ID == 6 || obj.ID == 7) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(4, 4, 6, 6);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Triggers</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={filterData.ProgramID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0,
                    0,
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"program" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={filterData.QuarterID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quarter" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            {globalState.AppAccessLevelData.DID == 0 && (
              <div>
                <select
                  className="select-lg"
                  value={filterData.IBBScorecardID}
                  onChange={(e) =>
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      IBBScorecardID: Number(e.target.value),
                    }))
                  }
                >
                  <option value={0} key={"importer" + 0}>
                    All
                  </option>
                  {importerList &&
                    importerList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"importer" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <span style={{ width: "33.33%" }}></span>
          </div>

          <div className="form-btns">
            <a
              className="btn-primary btn-grid btn-secs"
              onClick={() => {
                globalState.setConfirmationObject({
                  ShowPopup: true,
                  Heading: "Confirmation - Send Targets To Importers",
                  Message: "Are you sure you want to send this email?",
                  ID: 1,
                  SelectedID: 1,
                });
              }}
            >
              Send Targets To Importers
            </a>
            <span
              className="pointer"
              onClick={() => {
                GetUserListApplicationAccessSettingsForAccessObject(3, 2);
              }}
            >
              <img src="images/info.png" width={14} height={14} alt="info" />
            </span>
            <a
              className="btn-primary btn-grid btn-secs"
              onClick={() => {
                globalState.setConfirmationObject({
                  ShowPopup: true,
                  Heading: "Confirmation - Start Actual Input",
                  Message: "Are you sure you want to send this email?",
                  ID: 2,
                  SelectedID: 2,
                });
              }}
            >
              Start Actual Input
            </a>
            <span
              title="Get Recipients List"
              className="pointer"
              onClick={() => {
                GetUserListApplicationAccessSettingsForAccessObject(3, 3);
              }}
            >
              <img src="images/info.png" width={14} height={14} alt="info" />
            </span>
            <a
              className="btn-primary btn-grid btn-secs"
              onClick={() => {
                globalState.setConfirmationObject({
                  ShowPopup: true,
                  Heading: "Confirmation - Share Initial Actual Scorecard",
                  Message: "Are you sure you want to send this email?",
                  ID: 3,
                  SelectedID: 3,
                });
              }}
            >
              Share Initial Actual Scorecard
            </a>
            <span
              title="Get Recipients List"
              className="pointer"
              onClick={() => {
                GetUserListApplicationAccessSettingsForAccessObject(3, 4);
              }}
            >
              <img src="images/info.png" width={14} height={14} alt="info" />
            </span>
            <a
              className="btn-primary btn-grid btn-secs"
              onClick={() => {
                globalState.setConfirmationObject({
                  ShowPopup: true,
                  Heading: "Confirmation - Start Exceptions Input",
                  Message: "Are you sure you want to send this email?",
                  ID: 4,
                  SelectedID: 4,
                });
              }}
            >
              Start Exceptions Input
            </a>
            <span
              title="Get Recipients List"
              className="pointer"
              onClick={() => {
                GetUserListApplicationAccessSettingsForAccessObject(3, 5);
              }}
            >
              <img src="images/info.png" width={14} height={14} alt="info" />
            </span>

            <a
              className="btn-primary btn-grid btn-secs"
              onClick={() => {
                globalState.setConfirmationObject({
                  ShowPopup: true,
                  Heading: "Confirmation - Share Final Scorecard",
                  Message: "Are you sure you want to send this email?",
                  ID: 6,
                  SelectedID: 6,
                });
              }}
            >
              Share Final Scorecard
            </a>
            <span
              title="Get Recipients List"
              className="pointer"
              onClick={() => {
                GetUserListApplicationAccessSettingsForAccessObject(3, 6);
              }}
            >
              <img src="images/info.png" width={14} height={14} alt="info" />
            </span>
          </div>
        </div>
      </div>

      {showUserList && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner rec-help" style={{ paddingBottom: 10 }}>
              <div className="help-head" style={{ margin: 0 }}>
                <h3>Recipients</h3>
                <a
                  className="close-help"
                  onClick={() => setShowUserList(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="rec-grid">
                {JLRRecipientsList.length > 0 && (
                  <div className="rec-list">
                    <span className="rec-head">All Brands Recipients:</span>
                    <ul>
                      {JLRRecipientsList &&
                        JLRRecipientsList.map((item: any, index: any) => (
                          <React.Fragment key={"jlruser" + index}>
                            {1 == 1 && (
                              <li>
                                {item.FirstName} {item.LastName} ({item.Email})
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                    </ul>
                  </div>
                )}
                {ImporterRecipientsList.length > 0 && (
                  <div className="rec-list">
                    <span className="rec-head">Importer Recipients:</span>
                    <ul>
                      {ImporterRecipientsList &&
                        ImporterRecipientsList.map((item: any, index: any) => (
                          <React.Fragment key={"jlruser" + index}>
                            {1 == 1 && (
                              <li>
                                {item.DealerName}: {item.FirstName}{" "}
                                {item.LastName} ({item.Email})
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="help-btns">
                <a onClick={() => setShowUserList(false)}>Close</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner" style={{ paddingBottom: 10 }}>
              <div className="help-head" style={{ margin: 0 }}>
                <h3>Message</h3>
                <a className="close-help" onClick={() => setShowPopup(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="section-table copa-sum-tab">
                Email has been scheduled and will be sent out shortly.
              </div>
              <div className="help-btns">
                <a onClick={() => setShowPopup(false)}>Close</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
